import { useListingMatchVersions } from "./use-listing-match-versions";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router";
import { Button } from "@/components/design/Button";
import { userErrorMessage } from "@/lib/user-error";
import type { DashboardContext } from "@/pages/project/dashboard-kinds";
import { ListingField } from "./ListingField";

export function ListingMatchField({ ctx }: { ctx: DashboardContext }) {
  const intl = useIntl();
  const query = useListingMatchVersions(ctx.entity.matchIds.length ? ctx.entity.id : undefined);
  const matches = query.data?.listing?.matches ?? [];
  const active = matches.filter(m => m.listingVersion?.state === "ACTIVE" || !m.listingVersion);
  const pending = matches.filter(m => m.listingVersion?.state === "RUNNING" || m.listingVersion?.state === "FAILED")
    .sort((a, b) => (b.listingVersion?.number ?? 0) - (a.listingVersion?.number ?? 0))[0];
  if (!ctx.entity.matchIds.length && !ctx.entity.actions.canManageMatches) return null;
  return <ListingField label={<FormattedMessage id="project.facet.kandidaten.label" />}>
    <div className="space-y-2">
      {active.map(match => <div key={match.id}>
        <Link id={`listing-overview-match-${match.id}`} to={`/match/${match.id}`} className="underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30">
          {match.name || <FormattedMessage id="share.listings.ranking.openMatch" />}</Link>
        <p className="smycles-field-meta text-ink-muted">{match.listingVersion ? <><FormattedMessage id="share.listings.versions.current" values={{ number: match.listingVersion.number }} /> · </> : null}
          <FormattedMessage id={match.autoMatch ? "share.listings.overview.autoOn" : "share.listings.overview.autoOff"} /></p>
      </div>)}
      {pending ? <p className="smycles-field-meta" role="status"><FormattedMessage id={pending.listingVersion?.state === "RUNNING"
        ? "share.listings.versions.running" : "share.listings.versions.failed"} values={{ number: pending.listingVersion?.number }} /></p> : null}
      {query.loading && !matches.length ? <p className="smycles-field-meta"><FormattedMessage id="common.loading" /></p> : null}
      {query.error ? <p role="alert" className="smycles-field-meta">{userErrorMessage(intl, query.error)}</p> : null}
      <Button id="listing-overview-matches" variant="ghost" size="sm" onClick={() => ctx.openFacet("kandidaten")}>
        <FormattedMessage id={ctx.entity.matchIds.length ? "share.listings.overview.matchDetails" : "share.listings.overview.matchSetup"} />
      </Button>
    </div>
  </ListingField>;
}
